import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const url = environment.wsUrl;

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }
 
  changePassword(req): Observable<any>{
    return this.http.post(url + 'xccm/user/change/password',req)
  }
}
